import { Layout } from './Layout';
import { DetailsPageSkeleton } from './Skeleton';

export function DetailsPageSkeletonWithLayout() {
  return (
    <Layout>
      <DetailsPageSkeleton />
    </Layout>
  );
}
